import {
	collection,
	getDocs,
	addDoc,
	updateDoc,
	serverTimestamp
}
from "firebase/firestore";

import { db }
from "../firebase/firebaseConfig";

import calcularViabilidadRuta
from "./calcularViabilidadRuta";

import generarRutaEstudio
from "./generarRutaEstudio";

import generarCronogramaRuta
from "./generarCronogramaRuta";

const crearActualizarRutaEstudio =
async ({

	userId,

	examenObjetivo,

	fechaObjetivo,

	horasSemana
}) => {

	const rutasSnap =
		await getDocs(
			collection(
				db,
				"rutas_estudio"
			)
		);

	const rutaActiva =
		rutasSnap.docs.find(
			doc => {

				const data =
					doc.data();

				return (
					data.userId ===
					userId
					&&
					data.activa === true
				);
			}
		);

	const {
		diasRestantes,

		estadoViabilidad
	} =
		calcularViabilidadRuta(
			fechaObjetivo
		);

		const rutaGenerada =
		await generarRutaEstudio(
			userId
		);	

		const cronograma = [];

	if (rutaActiva) {
		await updateDoc(
			rutaActiva.ref,
			{
		
				examenObjetivo,
		
				fechaObjetivo,
		
				horasSemana,
		
				diasRestantes,
		
				estadoViabilidad,
		
				ultimaReplanificacion:
					serverTimestamp(),
		
				fechaUltimaActualizacion:
					serverTimestamp(),
		
				avanceGeneral:
					Math.round(
						(
							rutaGenerada.dominados /
							Math.max(
								rutaGenerada.totalTemas,
								1
							)
						) * 100
					),
		
				temasPrioritarios:
					rutaGenerada.temasPrioritarios
						.map(
							t => t.temaId
						)
						.slice(0, 10)
						,

cronograma

			}
		);

		return rutaActiva.id;
	}


	const nuevaRuta =
		await addDoc(
			collection(
				db,
				"rutas_estudio"
			),
			{

				userId,

				activa: true,

				examenObjetivo,

				fechaObjetivo,

				horasSemana,

				diasRestantes,

				estadoViabilidad,

				

				simulacrosRealizados: 0,

				avanceGeneral:
				Math.round(
					(
						rutaGenerada.dominados /
						Math.max(
							rutaGenerada.totalTemas,
							1
						)
					) * 100
				),                

temasPrioritarios:
	rutaGenerada.temasPrioritarios
		.map(
			t => t.temaId
		)
		.slice(0, 10),

		cronograma,

				fechaCreacion:
					serverTimestamp(),

				fechaUltimaActualizacion:
					serverTimestamp(),

				ultimaReplanificacion:
					serverTimestamp()
			}
		);

		console.log(
			"CRONOGRAMA GENERADO"
		);
		
		console.log(
			JSON.stringify(
				cronograma[0],
				null,
				2
			)
		);

	return nuevaRuta.id;
};

export default
	crearActualizarRutaEstudio;